// The bank's name, with known banks suggested as it's typed (lib/bankDirectory.js). Picking one fills its
// routing and fractional numbers; any other name can be typed.
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { suggest } from "../lib/bankDirectory";

export default function BankNameField({ value, onChange, onPick, directory, state, className }) {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const [active, setActive] = useState(0);
  const list = open ? suggest(directory, value, state) : [];
  const choose = (s) => { onPick(s); setOpen(false); };
  const keys = (e) => {
    if (!list.length) return;
    if (e.key === "ArrowDown") { e.preventDefault(); setActive((a) => Math.min(a + 1, list.length - 1)); }
    else if (e.key === "ArrowUp") { e.preventDefault(); setActive((a) => Math.max(a - 1, 0)); }
    else if (e.key === "Enter") { e.preventDefault(); choose(list[active]); }
    else if (e.key === "Escape") setOpen(false);
  };
  return (
    <div className="relative">
      <input className={className} value={value || ""} maxLength={80} autoComplete="off" role="combobox"
        aria-expanded={list.length > 0} aria-controls="bank-suggestions" aria-autocomplete="list"
        placeholder={t("bank_name_placeholder")}
        onChange={(e) => { onChange(e.target.value); setOpen(true); setActive(0); }} onFocus={() => setOpen(true)}
        onBlur={() => setTimeout(() => setOpen(false), 150)} onKeyDown={keys} />
      {list.length > 0 && (
        <ul id="bank-suggestions" role="listbox"
          className="absolute z-20 left-0 right-0 mt-1 p-1 bg-white border border-gray-200 rounded-lg shadow-lg max-h-72 overflow-y-auto">
          {list.map((s, i) => (
            <li key={s.routing} role="option" aria-selected={i === active}
              className={`px-2 py-1.5 rounded cursor-pointer text-sm ${i === active ? "bg-gray-100" : ""}`}
              onMouseDown={(e) => { e.preventDefault(); choose(s); }} onMouseEnter={() => setActive(i)}>
              <span className="font-medium">{s.bankName}</span>{s.place ? ` (${s.place})` : ""}
              <span className="text-gray-500 text-xs"> · {s.states.join(", ")} · {s.routing} · {s.fraction}</span>
            </li>
          ))}
          <li className="px-2 py-1 text-xs text-gray-500" aria-hidden="true">{t("bank_type_your_own")}</li>
        </ul>
      )}
    </div>
  );
}
